module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/pages/help-center-article-b3b278c1f02e4147b58e430b91233430.jpg";